export default Object.freeze({
    ENABLE_COOKIE_CONSENT: process.env.VUE_APP_ENABLE_COOKIE_CONSENT === 'true',
});
